(function () {
  const toBoolean = (value) => value === "true";

  const initSlider = (section) => {
    if (!section) return;

    const slider = section.querySelector(".social-media__slider");
    if (!slider || typeof Swiper === "undefined") return;

    // Avoid double init (e.g. section reloaded in the theme editor).
    if (slider.swiper) slider.swiper.destroy(true, true);

    const slides = slider.querySelectorAll(".social-media__slide");
    if (!slides.length) return;

    const perViewDesktop = Number(slider.dataset.desktop) || 6;
    const perViewMobile = Number(slider.dataset.mobile) || 2;
    const perViewTablet = Math.max(
      perViewMobile,
      Math.round((perViewMobile + perViewDesktop) / 2)
    );

    const speed = (Number(slider.dataset.speed) || 1.1) * 1000;
    const delay = (Number(slider.dataset.delay) || 3) * 1000;
    const autoplay = toBoolean(slider.dataset.autoplay);
    const stopOnHover = toBoolean(slider.dataset.stopAutoplay);
    const showNavigation = toBoolean(slider.dataset.navigation);
    const showPagination = toBoolean(slider.dataset.pagination);

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    // Hide the whole controls bar when the slider can't slide (Swiper's
    // watchOverflow re-evaluates this per breakpoint via `isLocked`).
    const controls = section.querySelector(".swiper-controllers");
    const syncControls = (instance) => {
      if (controls) controls.classList.toggle("hidden", instance.isLocked);
    };

    let params = {
      speed: speed,
      keyboard: true,
      // No loop: keep real first/last slides so the arrows disable at the ends
      // (autoplay still rewinds to the start via Swiper's stopOnLastSlide: false).
      loop: false,
      watchOverflow: true,
      slidesPerView: perViewMobile,
      spaceBetween: 16,
      breakpoints: {
        576: {
          slidesPerView: perViewTablet,
        },
        1100: {
          slidesPerView: perViewDesktop,
          spaceBetween: 24,
        },
      },
      on: {
        afterInit: syncControls,
        lock: syncControls,
        unlock: syncControls,
        resize: syncControls,
      },
    };

    if (showNavigation) {
      params.navigation = {
        nextEl: section.querySelector(".swiper-button-next"),
        prevEl: section.querySelector(".swiper-button-prev"),
      };
    }

    if (showPagination) {
      params.pagination = {
        el: section.querySelector(".swiper-pagination"),
        clickable: "true",
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return `
            <span class="current-slide">${
              current < 10 ? "0" + current : current
            }</span>
            <span class="swiper-pagination-delimiter"></span>
            <span class="total-slides">${
              total < 10 ? "0" + total : total
            }</span>`;
        },
      };
    }

    if (autoplay && !reduceMotion) {
      params.autoplay = {
        delay: delay,
        pauseOnMouseEnter: stopOnHover,
        disableOnInteraction: false,
      };
    }

    new Swiper(slider, params);
  };

  const initAll = () => {
    document
      .querySelectorAll(".social-media-section")
      .forEach((section) => initSlider(section));
  };

  initAll();

  document.addEventListener("shopify:section:load", function (event) {
    const target = event.target;
    if (target.classList.contains("social-media-section")) {
      initSlider(target);
    } else {
      const section = target.querySelector(".social-media-section");
      if (section) initSlider(section);
    }
  });

  // Restart autoplay after the tab regains focus (Swiper pauses when hidden).
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) return;
    document.querySelectorAll(".social-media__slider").forEach((slider) => {
      const instance = slider.swiper;
      if (
        instance &&
        !instance.isLocked &&
        instance.params.autoplay &&
        instance.autoplay
      ) {
        instance.autoplay.start();
      }
    });
  });
})();
